import axios from "@/utils/axios";
import {ip3} from "@/utils/constants";

export async function getCameraDonVi(payload: {
  page: number;
  limit: number;
  cond?: any;
  donViId?: string;
}) {
  const { page, limit, cond,donViId } = payload;
  const cloneCond = JSON.parse(JSON.stringify(cond));
  delete cloneCond.organizationId;
  return axios.get(`${ip3}/camera/pageable`, {
    params: {
      page,
      limit,
      cond: {
        ...cloneCond,
      },
      donViId: donViId
    },
  });
}

export async function addCamera(payload: any) {
  return axios.post(`${ip3}/camera`, payload);
}

export async function updateCamera(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/camera/${id}`, payload);
}

export async function deleteCamera(id: string) {
  return axios.delete(`${ip3}/camera/${id}`);
}
